export default __webpack_public_path__ + "static/ci-cd-intelligente-machine-learning-1-2e5a7c2bbeb8a599caeb2613b0a479b0.jpg";